import { createContext, useContext } from 'react';

import { SearchUser } from '../../queries/search';
import { SearchBonus } from '../../types/bonus';

export const createSearchContext = () => ({
	bonuses: [] as SearchBonus[],
	bonusCount: 0,
	isFetching: false,
	hasAllRecords: false,
	hasAnyRecords: false,
	hasBonuses: false,
	hasUsers: false,
	query: '',
	recordCount: 0,
	userCount: 0,
	users: [] as SearchUser[],
});

export type SearchContextValue = ReturnType<typeof createSearchContext>;

export const SearchContext = createContext<SearchContextValue>(createSearchContext());

export const useSearchContext = () => useContext(SearchContext);
